module.exports = __webpack_public_path__ + "img/tools_super_compensation.1fa94d83.jpg";